import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/arrowVertical.tsx
var ArrowVertical = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M8 5.49997L11.2929 2.20708C11.6834 1.81655 12.3166 1.81655 12.7071 2.20708L16 5.49997M8 18.5L11.2929 21.7929C11.6834 22.1834 12.3166 22.1834 12.7071 21.7929L16 18.5M12 21.5V2.49997",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M8 5.49997L11.2929 2.20708C11.6834 1.81655 12.3166 1.81655 12.7071 2.20708L16 5.49997M8 18.5L11.2929 21.7929C11.6834 22.1834 12.3166 22.1834 12.7071 21.7929L16 18.5M12 21.5V2.49997",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
//#endregion
export { ArrowVertical };
